import { useState } from 'react'
import machines from '../resources/equip.json'

export default function MachinesSection() {
  const [activeSlug, setActiveSlug] = useState(machines[0].slug)

  const activeMachine = machines.find(machine => machine.slug === activeSlug)

  return (
    <div className='machines-layout'>
      {/* Sidebar */}
      <div className='sidebar'>
        {machines.map(machine => (
          <button
            key={machine.slug}
            onClick={() => setActiveSlug(machine.slug)}
            className={machine.slug === activeSlug ? 'active' : ''}
          >
            {machine.title}
          </button>
        ))}
      </div>

      {/* Pravý blok */}
      <div
        className='detail-background'
        style={{ backgroundImage: `url(${activeMachine.path})` }}
      >
        <div className='detail-overlay'>
          <h2 className='detail-title'>{activeMachine.title}</h2>
          <p className='detail-description'>{activeMachine.desc}</p>
        </div>
      </div>
    </div>
  )
}
